import React, { MouseEventHandler } from "react";
import {
  styled,
  $fontSize,
  $fontWeightLight
} from "@acko-tech/building-blocks.ui.common";
import { isnpBasePath } from "@utils/isnp";

interface TapToCopyProps {
  style?: any;
  clickHandler?: MouseEventHandler;
}

const TermAndConText = styled.div`
  margin-top: 8px;
  color: #5b5675;
  font-weight: ${$fontWeightLight};
  font-size: ${$fontSize.xxs};
  line-height: 16px;
  ${props => props.styles}
  & > span > a {
    color: #1b73e8;
    text-decoration: none;
  }
`;

export default function TermAndCondition({
  style,
  clickHandler
}: TapToCopyProps) {
  return (
    <TermAndConText styles={style}>
      By proceeding, you agree to the{" "}
      <span>
        <a
          onClick={clickHandler}
          href={`${process.env.HOST_URL}${isnpBasePath}/terms-and-conditions/`}
          target="_blank"
        >
          Terms & Conditions
        </a>
      </span>
    </TermAndConText>
  );
}
